import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordDescriptionDataClassName = DataClassName.TIMERECORD_DESCRIPTION
const timerecordDescriptionEndpoint =
  PisaDataClassEndpoint.TIMERECORD_DESCRIPTION

export function pisaTimerecordDescriptionDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordDescriptionDataClassName, {
    title: timerecordDescriptionDataClassName,
    restApi: createPisaRestApiConfig(timerecordDescriptionEndpoint),
    attributes,
  })
}
